import { Filter, Layers3, Network, Search, ShieldCheck } from "lucide-react";

import { Input } from "@/components/ui/input";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { BlockchainNetworkQuery } from "@/interfaces/blockchainNetwork";

interface Props {
  query: BlockchainNetworkQuery;

  onChange: (query: BlockchainNetworkQuery) => void;
}

const BlockchainNetworkFilters = ({ query, onChange }: Props) => {
  return (
    <div className="rounded-2xl border bg-card p-5">
      <div className="mb-5 flex items-center gap-2">
        <Filter className="h-5 w-5 text-primary" />
        <h2 className="font-semibold">Search & Filters</h2>
      </div>

      <div className="grid gap-4 xl:grid-cols-5">
        {/* Search */}

        <div className="relative xl:col-span-2">
          <Search className="absolute left-3 top-3.5 h-4 w-4 text-muted-foreground" />

          <Input
            className="pl-10"
            placeholder="Search network..."
            value={query.search ?? ""}
            onChange={(e) =>
              onChange({
                ...query,
                page: 1,
                search: e.target.value,
              })
            }
          />
        </div>

        {/* Status */}

        <Select
          value={
            query.enabled === undefined
              ? "ALL"
              : query.enabled
                ? "ENABLED"
                : "DISABLED"
          }
          onValueChange={(value) => {
            onChange({
              ...query,
              page: 1,
              enabled: value === "ALL" ? undefined : value === "ENABLED",
            });
          }}
        >
          <SelectTrigger>
            <ShieldCheck className="mr-2 h-4 w-4" />

            <SelectValue placeholder="Status" />
          </SelectTrigger>

          <SelectContent>
            <SelectItem value="ALL">All Status</SelectItem>

            <SelectItem value="ENABLED">Enabled</SelectItem>

            <SelectItem value="DISABLED">Disabled</SelectItem>
          </SelectContent>
        </Select>

        {/* Network */}

        <Select
          value={query.networkType ?? "ALL"}
          onValueChange={(value) =>
            onChange({
              ...query,
              page: 1,
              networkType: value === "ALL" ? undefined : (value as any),
            })
          }
        >
          <SelectTrigger>
            <Network className="mr-2 h-4 w-4" />

            <SelectValue />
          </SelectTrigger>

          <SelectContent>
            <SelectItem value="ALL">All Networks</SelectItem>

            <SelectItem value="MAINNET">Mainnet</SelectItem>

            <SelectItem value="TESTNET">Testnet</SelectItem>
          </SelectContent>
        </Select>

        {/* Architecture */}

        <Select
          value={query.architecture ?? "ALL"}
          onValueChange={(value) =>
            onChange({
              ...query,
              page: 1,
              architecture: value as any,
            })
          }
        >
          <SelectTrigger>
            <Layers3 className="mr-2 h-4 w-4" />

            <SelectValue />
          </SelectTrigger>

          <SelectContent>
            <SelectItem value="ALL">All Architectures</SelectItem>

            <SelectItem value="EVM">EVM</SelectItem>

            <SelectItem value="UTXO">UTXO</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default BlockchainNetworkFilters;
